<template>
  <div class="modal-data-acao-auto">
    <v-dialog v-model="dialog" @input="cancel" width="800">
      <v-card>
        <v-card-title>Justificativa</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-textarea
              outlined
              v-model="justificativa"
              label="Justificativa"
              :rules="required"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click.prevent="confirm(justificativa)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ModalJustificativa",
  data() {
    return {
      dialog: false,
      required: [v => !!v || "Este Campo é Obrigatório"],
      valid: true,
      justificativa: null,
      resolve: null,
      reject: null
    };
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        this.dialog = true;
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel() {
      this.reject();
      this.close();
    },
    confirm(justificativa) {
      if (!this.$refs.form.validate()) return;
      this.resolve(justificativa);
      this.close();
    },
    close() {
      this.$refs.form.reset();
      this.dialog = false;
    }
  }
};
</script>
